import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { filter, interval, of, switchMap, takeUntil } from 'rxjs';
import { VaSessionActions } from './va-session.actions';
import { Store } from '@ngrx/store';
import { selectIsConnected } from '../live-chat/live-chat.reducer';
import { selectVaSessionState } from './va-session.reducer';
import { MainComponentActions } from '../main.actions';
import { TranslateService } from '@ngx-translate/core';
import { VaButtonActions } from '../va-button/va-button.actions';

@Injectable({
  providedIn: 'root',
})
export class VaSessionEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private translateService: TranslateService
  ) {}

  validateSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MainComponentActions.mainComponentLoaded),
      switchMap(() => interval(60000)), // Every one minute
      takeUntil(
        this.actions$.pipe(ofType(MainComponentActions.mainComponentDestroyed))
      ),
      concatLatestFrom(() => this.store.select(selectVaSessionState)),
      filter(
        ([, vaSessionState]) =>
          vaSessionState.expiryDate && !vaSessionState.isSessionExpired
      ),
      switchMap(([, vaSessionState]) => {
        if (Date.now() >= vaSessionState.expiryDate.getTime()) {
          return of(VaSessionActions.expireSession());
        }
        return of(VaSessionActions.setSessionValid());
      })
    )
  );

  updateVaButtonPopOverText$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VaSessionActions.expireSession),
      concatLatestFrom(() => this.store.select(selectIsConnected)),
      filter(([, isConnected]) => !isConnected),
      switchMap(() => {
        const popOverText = this.translateService.instant(
          'SESSION_EXPIRED_TEXT'
        );
        return of(VaButtonActions.onSessionExpired({ popOverText }));
      })
    )
  );
}
